﻿import { ITranslation } from "@/interfaces";
import { IntlShape } from "react-intl";

export const getLookupValues = (
  itemsMap: { [id: string]: ITranslation },
  intl: IntlShape
): { [key: string]: string } => {
  const lookupValues: { [key: string]: string } = {};
  Object.keys(itemsMap).forEach((formGuid: string) => {
    const { id, fallback } = itemsMap[formGuid];
    lookupValues[formGuid] = intl.formatMessage({
      id,
      defaultMessage: fallback,
    });
  });
  return lookupValues;
};
